<style lang="less">
@import "../css/login.less";
.loginBox.login-page {
    position: relative;
    background: url('/new-ui/login_bg.png') no-repeat center center;
    background-size: cover;
    .loginCard {
        background: url('/new-ui/login_model_bg.png') no-repeat center center;
        background-size: 100% 100%;
    }
}
</style>
<template>
    <div class="loginBox login-page">
        <div class="loginCard">
            <img class="titleImg" src="/new-ui/title1.png">
            <div class="loginBody">
                <el-form ref="loginForm" :model="login" :rules="loginRules" @submit.native.prevent="doLogin" style="width: 100%">
                    <el-form-item prop="username">
                        <el-input v-model="login.username" placeholder="请输入用户名" style="width: 100%" prefix-icon="el-icon-user"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="login.password" placeholder="请输入密码" style="width: 100%" prefix-icon="el-icon-lock" type="password"></el-input>
                    </el-form-item>
                    <el-form-item prop="yzm">
                        <div class="yzmBox">
                            <el-input v-model="login.yzm" placeholder="请输入验证码" style="width: calc(100% - 130px)" prefix-icon="el-icon-aim" type="password"></el-input>
                            <el-image class="yzm" :src="captchaUrl" @click="reloadYzm" ref="yzm"></el-image>
                        </div>
                    </el-form-item>
                    <el-button type="primary" native-type="submit" class="loginBtn">登录</el-button>
                </el-form>
                <span class="msg">{{msg}}</span>
            </div>
        </div>
        <div class="login-copyright">智能灌浆系统 © 2022-2026<br>dy-gj.cn</div>
    </div>
</template>

<script>
import {login} from '@/api/login'
import { generateUUID } from '@/libs/util'
import config from '@/config';
import md5 from 'js-md5';
import axios from 'axios';
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev1 : config.baseUrl.pro+'/api'

export default {
    name: 'login',
    data() {
        return {
            title: config.title,
            imgServer: config.imgServer,
            login: {
                username: '',
                password: '',
                sub_pass: '',
                yzm: '',
            },
            msg: '',
            loginRules: {
                username: [
                    {required: true, message: '用户名不能为空', trigger: 'blur'}
                ],
                password: [
                    {required: true, message: '密码不能为空', trigger: 'blur'}
                ],
                yzm: [
                    {required: true, message: '验证码不能为空', trigger: 'blur'}
                ]
            },
            timestamp: new Date().getTime(),
            baseURL: baseUrl,
            uuid: '',
            // 验证码图片的 blob URL，由 loadCaptcha() 请求后赋值
            captchaUrl: ''
        }
    },
    mounted() {
        // 与 axios.js 中共用的全局 uuid 保持一致，用于后端会话校验（例如验证码请求）
        let REQUEST_UUID = localStorage.getItem("REQUEST_UUID");
        if (REQUEST_UUID == null || REQUEST_UUID == "") {
            REQUEST_UUID = generateUUID();
            localStorage.setItem("REQUEST_UUID", REQUEST_UUID);
        }
        this.uuid = REQUEST_UUID
        this.loadCaptcha()
    },
    beforeDestroy() {
        // 组件销毁时释放 blob URL，避免内存泄漏
        if (this.captchaUrl) {
            window.URL.revokeObjectURL(this.captchaUrl)
            this.captchaUrl = ''
        }
    },
    methods: {
        doLogin(){
            this.$refs['loginForm'].validate((valid) => {
                if (valid) {
                    let temp = md5(this.login.password).toUpperCase()
                    this.login.sub_pass = md5(this.login.username+temp)
                    login(this.login.username, this.login.sub_pass, this.login.yzm).then(res=>{
                        localStorage.removeItem("navIds")
                        localStorage.removeItem("navTags")
                        localStorage.removeItem("actMenu")
                        if(res.code == 1){
                            localStorage.setItem("cos_domain", res.data.cos_domain)
                            localStorage.setItem("home_page", res.data.home_page || '')
                            sessionStorage.setItem("U_TOKEN", res.msg)
                            localStorage.setItem("user_id", res.data.user_id || 0)
                            this.$router.push({path: '/home'})
                        }else if(res.code ==2 || res.code ==3 || res.code == 4){
                            localStorage.setItem("cos_domain", res.data.cos_domain)
                            localStorage.setItem("user_id", res.data.user_id || 0)
                            this.$router.push({path: '/map'})
                        }else{
                            this.msg = res.msg
                        }
                    })
                } else {
                    return false;
                }
            });
            return false
        },
        loadCaptcha(){
            // 释放上一次的 blob URL，避免内存泄漏
            if (this.captchaUrl) {
                window.URL.revokeObjectURL(this.captchaUrl)
                this.captchaUrl = ''
            }
            // 直接用原生 axios，不走 @/libs/api.request 的拦截器（拦截器会对 res.data.code 做判断，不适用于图片二进制响应）
            // uuid 放在 header 中，timestamp 保留作为防缓存参数
            // 使用相对路径 /api/admin/captcha：
            //   开发环境下由 vue.config.js 的 devServer.proxy 将 /api 代理到 http://192.168.1.105:8081，同源请求不会触发 CORS 预检
            //   生产环境下依靠 nginx 反向代理 /api，与其他 @/api/*.js 接口保持一致
            const url = '/api/admin/captcha'
            axios.get(url, {
                params: { timestamp: this.timestamp },
                headers: { uuid: this.uuid },
                responseType: 'blob'
            }).then(res => {
                // 后端如果返回的是 JSON（例如错误信息），responseType: 'blob' 仍会包装成 Blob，需要识别后提示真实原因
                const contentType = (res.headers && (res.headers['content-type'] || res.headers['Content-Type'])) || ''
                if (contentType.indexOf('application/json') !== -1 || contentType.indexOf('text/') !== -1) {
                    const reader = new FileReader()
                    reader.onload = () => {
                        console.error('[captcha] 后端返回非图片响应:', reader.result)
                        this.$message.error('验证码接口返回异常，请查看控制台')
                    }
                    reader.readAsText(res.data)
                    return
                }
                this.captchaUrl = window.URL.createObjectURL(res.data)
            }).catch(err => {
                // 详细输出错误信息，方便定位是 CORS、4xx/5xx 还是网络问题
                if (err && err.response) {
                    // 请求已到达服务器，服务器返回了非 2xx 状态码
                    console.error('[captcha] 请求失败 status=', err.response.status, 'statusText=', err.response.statusText, 'data=', err.response.data)
                    this.$message.error('验证码加载失败(' + err.response.status + ')，请重试')
                } else if (err && err.request) {
                    // 请求已发出但没有收到响应，常见于 CORS 预检失败 / 网络不通 / 后端未启动
                    console.error('[captcha] 无响应，可能是 CORS 预检失败或网络不通。url=', url, 'uuid=', this.uuid, 'err=', err.message)
                    this.$message.error('验证码请求无响应，请检查后端 CORS 配置或网络')
                } else {
                    console.error('[captcha] 其他错误:', err && err.message)
                    this.$message.error('验证码加载失败，请重试')
                }
            })
        },
        reloadYzm(){
            // 使用时间戳作为随机参数避免浏览器缓存，并重新拉取验证码
            this.timestamp = new Date().getTime();
            this.loadCaptcha();
        },
    }
}
</script>